export default "__VITE_ASSET__pjzmy79K__"